import { compose, hoistStatics, lifecycle, withHandlers, withState } from 'recompose';
import { translate } from 'react-i18next';
import { withRouter } from 'react-router-dom';

import SearchedPosts from './SearchedPosts';
import WithLoading from '../../../../components/WithLoading';
import KbPostService from '../../../../services/kbPost.service';


const callbackToSetSearch = props => async (value) => {
  const { setSearchedPosts,
    searchCriteria,
    setSearchCriteria,
    setSearchedPostsCount,
    setIsLoading,
    setHasMoreSearch,
  } = props;
  setIsLoading(true);
  const searchedPosts = await KbPostService.getData({ ...searchCriteria, search: value, page: 0 });
  if (searchCriteria.limit >= searchedPosts.count) setHasMoreSearch(false);
  else setHasMoreSearch(true);
  setSearchCriteria({ ...searchCriteria, search: value, page: 0 });
  setSearchedPosts(searchedPosts.data);
  setSearchedPostsCount(searchedPosts.count);
  setIsLoading(false);
};

const loadMore = props => async (nextPage) => {
  const {
    isLoading,
    setHasMoreSearch,
    searchedPosts,
    searchCriteria,
    setSearchedPosts,
    setSearchCriteria,
    searchedPostsCount,
    setSearchedPostsCount,
  } = props;
  if (!isLoading) {
    const page = nextPage > -1 ? nextPage : 0;
    if (searchCriteria.limit * (page + 1) >= searchedPostsCount) setHasMoreSearch(false);
    const { data, count } = await KbPostService.getData({ ...searchCriteria, page });
    if (data) {
      setSearchedPosts([...searchedPosts, ...data]);
      setSearchedPostsCount(count);
      setSearchCriteria({ ...searchCriteria, page });
    }
  }
};


const defaultCriteriaPostSearch = {
  sortBy: 'created_at',
  order: 'desc',
  page: 0,
  limit: 10,
};


const enhance = compose(
  translate('portal'),
  withState('isLoading', 'setIsLoading', true),
  withState('searchedPosts', 'setSearchedPosts', []),
  withState('hasMoreSearch', 'setHasMoreSearch', true),
  withState('searchedPostsCount', 'setSearchedPostsCount', 0),
  withState('searchCriteria', 'setSearchCriteria', defaultCriteriaPostSearch),
  lifecycle({
    async componentDidMount() {
      await callbackToSetSearch(this.props)(this.props.match.params.value);
    },
    async shouldComponentUpdate(nextProps) {
      if (nextProps.match.params.value !== this.props.match.params.value) {
        await callbackToSetSearch(nextProps)(nextProps.match.params.value);
      }
    },
  }),
  withHandlers({
    loadMore,
    callbackToSetSearch,
  }),
);

export default withRouter(hoistStatics(enhance)(WithLoading(SearchedPosts)));



// WEBPACK FOOTER //
// ./src/views/modules/kb/searchedPosts/index.js